import { defineStore } from "pinia"

export interface LocalUserSettingsStoreType {
  skipConfirmCloseWorkOrder: boolean
  skipConfirmWorkOrderRemoveItem: boolean
  skipConfirmWorkOrderRemoveIssue: boolean
  skipConfirmRemoveItemFromWorkOrder: boolean
  skipConfirmRemoveIssueFromWorkOrder: boolean
  skipUnsupportedBrowser: boolean
  extendedMenuState: {
    openWorkRelated: boolean
    openRegistryEntities: boolean
    openArrangement: boolean
    openAdmin: boolean
  }
}

export const useLocalUserSettingsStore = defineStore("pinia-localUserSettingsStore", {
  persist: true,

  state: (): LocalUserSettingsStoreType => ({
    skipConfirmCloseWorkOrder: false,
    skipConfirmWorkOrderRemoveItem: false,
    skipConfirmWorkOrderRemoveIssue: false,
    skipConfirmRemoveItemFromWorkOrder: false,
    skipConfirmRemoveIssueFromWorkOrder: false,
    skipUnsupportedBrowser: false,
    extendedMenuState: {
      openWorkRelated: false,
      openRegistryEntities: false,
      openArrangement: false,
      openAdmin: false,
    },
  }),
})
